import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { api, API } from "@/lib/api";
import { Megaphone, Paperclip, FileText } from "lucide-react";
import Logo from "@/components/app/Logo";

export default function Circular() {
  const { token } = useParams();
  const [data, setData] = useState(null);
  const [error, setError] = useState(false);

  useEffect(() => {
    (async () => {
      try { const r = await api.get(`/circular/${token}`); setData(r.data); }
      catch { setError(true); }
    })();
  }, [token]);

  if (error) return (
    <div className="min-h-screen bg-nardo-50 flex items-center justify-center px-6">
      <div className="text-center" data-testid="circular-error">
        <p className="text-navy font-display text-xl">Circular no disponible</p>
        <p className="text-nardo-500 text-sm mt-2">El enlace puede haber expirado o no es válido.</p>
      </div>
    </div>
  );

  if (!data) return (
    <div className="min-h-screen bg-nardo-50 flex items-center justify-center">
      <p className="text-nardo-500 text-sm">Cargando…</p>
    </div>
  );

  const attachUrl = data.attachment_token ? `${API}/aviso/${data.attachment_token}/archivo` : null;
  const isPdf = (data.attachment_name || "").toLowerCase().endsWith(".pdf");

  return (
    <div className="min-h-screen bg-nardo-50" data-testid="circular-page">
      <div className="h-[3px] w-full bg-navy" />
      <div className="max-w-2xl mx-auto px-6 py-10">
        <div className="flex items-center justify-between mb-8">
          {data.logo_url ? (
            <img src={`${API}${data.logo_url}`} alt={data.school_name} className="h-12 w-auto max-w-[200px] object-contain" data-testid="circular-school-logo" />
          ) : (
            <Logo />
          )}
          <span className="text-[11px] uppercase tracking-[0.25em] text-nardo-500">Comunicado oficial</span>
        </div>

        <div className="bg-white border border-nardo-200 rounded-md p-6 sm:p-8 relative">
          <div className="absolute top-0 left-0 h-[2px] w-16 bg-navy" />
          <div className="flex items-center gap-2 text-navy-light text-xs uppercase tracking-[0.2em] mb-4">
            <Megaphone className="w-4 h-4" /> {data.school_name || "Dirección"}
          </div>
          <h1 className="font-display font-extrabold text-2xl sm:text-3xl text-navy leading-tight">{data.title}</h1>
          {data.created_at && (
            <div className="text-xs text-nardo-400 mt-2">{new Date(data.created_at).toLocaleDateString("es-MX", { day: "numeric", month: "long", year: "numeric" })}</div>
          )}
          <p className="text-base text-nardo-700 mt-6 whitespace-pre-wrap leading-relaxed">{data.body}</p>

          {attachUrl && (
            <div className="mt-8 pt-6 border-t border-nardo-100">
              <a href={attachUrl} target="_blank" rel="noreferrer" data-testid="circular-attachment" className="inline-flex items-center gap-2 bg-navy hover:bg-navy-light text-white px-5 py-2.5 rounded-md text-sm font-medium transition-colors">
                {isPdf ? <FileText className="w-4 h-4" /> : <Paperclip className="w-4 h-4" />} Ver adjunto · {data.attachment_name || "Archivo"}
              </a>
              {!isPdf && (
                <div className="mt-4">
                  <img src={attachUrl} alt="Adjunto" className="max-w-full rounded-md border border-nardo-200" />
                </div>
              )}
            </div>
          )}

          {data.person && (
            <div className="mt-8 text-xs text-nardo-400">Dirigido a la familia de <span className="text-navy font-medium">{data.person}</span></div>
          )}
        </div>

        <div className="text-center text-[11px] text-nardo-400 mt-8 uppercase tracking-[0.2em]">ZAVIA</div>
      </div>
    </div>
  );
}
